/** Common citizenship country labels for assisted KYC (web + mobile aligned). */
export const CITIZENSHIP_COUNTRY_OPTIONS = [
  'Australia',
  'New Zealand',
  'United Kingdom',
  'Ireland',
  'United States',
  'Canada',
  'India',
  'China',
  'Hong Kong',
  'Taiwan',
  'Japan',
  'South Korea',
  'Philippines',
  'Vietnam',
  'Thailand',
  'Indonesia',
  'Malaysia',
  'Singapore',
  'Nepal',
  'Sri Lanka',
  'Pakistan',
  'Bangladesh',
  'Afghanistan',
  'Iran',
  'Iraq',
  'Lebanon',
  'Syria',
  'Turkey',
  'Egypt',
  'South Africa',
  'Nigeria',
  'Kenya',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Poland',
  'Ukraine',
  'Russia',
  'Brazil',
  'Argentina',
  'Chile',
  'Colombia',
  'Mexico',
  'Fiji',
  'Samoa',
  'Tonga',
  'Papua New Guinea',
  'Other',
]
